import ICalculatorConfiguration from "../../models/ICalculatorConfiguration";
import { ICalculatorInput } from "../../models/ICalculatorInput";
import filterPaperTypes from "./filterPaperTypes";

export default function filterInnerPaperTypes(
  pricingConfiguration: ICalculatorConfiguration,
  calculatorInput: ICalculatorInput,
) {
  const printingOption =
    pricingConfiguration.pricingConfiguration.printingOptions.filter(
      (po) => po.code === calculatorInput.selectedPrintingOption,
    )[0];
  if (printingOption.hasCover) {
    return filterPaperTypes(pricingConfiguration, calculatorInput).filter(
      (pt) => pt.useForInsideInBooklet === true,
    );
  } else {
    return filterPaperTypes(pricingConfiguration, calculatorInput);
  }
}
